export type ImportReviewState = {
  /** Step 2: VLAN & global subnet reviewed */
  vlanSubnetConfirmed: boolean;
  /** Steps 3–4: per node id (switches + devices share this map) */
  nodeReviewed: Record<string, boolean>;
  /** Step 5: per edge id */
  edgeReviewed: Record<string, boolean>;
  /** Step 6 */
  globalSettingsConfirmed: boolean;
};

export const INITIAL_IMPORT_REVIEW: ImportReviewState = {
  vlanSubnetConfirmed: false,
  nodeReviewed: {},
  edgeReviewed: {},
  globalSettingsConfirmed: false,
};
